import { matchPath, useLocation } from 'react-router';

/**
 * Both document template and spaces under project template
 * are referred to as document template in smartfills,
 * hence fetching the template id based on current route
 */
export const useActiveDocumentTemplateId = () => {
  const { pathname } = useLocation();
  const docTemplateRes = matchPath(pathname, {
    path: '/templates/documents/:templateId',
    exact: true,
  });
  let documentId = (docTemplateRes?.params as any)?.templateId;

  if (!documentId) {
    const projectTemplateSpaceRes = matchPath(pathname, {
      path: '/templates/projects/:templateId/spaces/:spaceId/tabs/:tabId',
      exact: true,
    });

    documentId = (projectTemplateSpaceRes?.params as any)?.tabId;
  }
  const docId = parseInt(documentId, 10);

  return docId;
};
